import { useContext, useState } from "react"

import UserContext from "../context/UserContext"
import Navbar from "../components/Navbar"
import NavbarWhitelisted from "../components/NavbarWhitelisted"

import { callSubscribeToSendyLambda } from '../api/utilityApi'


const Subscribe = () => {
  const { isWhitelisted } = useContext(UserContext)
  const [isSubscribed, setIsSubscribed] = useState(false)
  const [email, setEmail] = useState('')
  const [userMessage, setUserMessage] = useState('')

  /**
   * Note that domain restrictions are also defined in the lambda function cognitoDomainRestrictFcc:
   * These restrictions should be kept in sync with the restrictions in the lambda function.
   */
  const isValidEmailDomain = (email) => {
    try {
      const validDomains = ["@fcc.gov"]
      const domain = email.substring(email.lastIndexOf("@"))
      return validDomains.includes(domain)
    } catch {
      return false
    }
  }

  const subscribeHandler = () => {
    setUserMessage('')

    // Form validation
    if(email.length === 0) {
      setUserMessage("Invalid email")
      return
    } else if (!isValidEmailDomain(email)) {
      setUserMessage("Invalid email domain")
      return
    }

    // Call lambda function
    callSubscribeToSendyLambda(email)
    setIsSubscribed(true)
  }


  return (
    <>
      {isWhitelisted ? <NavbarWhitelisted /> : <Navbar />}

      <div className="container-fluid banner text-center text-white">
        Subscription Request
      </div>
      

      {isSubscribed ? (
        <div className="text-center">
          <br/>
          <h2>Thank You for your Interest</h2>
          <br/>
          Your email has been submitted for consideration to be added to the daily distribution.<br/>
          You will receive the daily distribution as soon as our team approves this request.
        </div>
      ) : (
      <div className="row d-flex justify-content-center">
        <div className="mr-auto ml-auto col-lg-6 col-xl-4 col-md-6 bg-dark text-white my-5 p-4 rounded">

          <br/>
          <div className="form-group py-2 fs-4">
            Email
            <div>
              <input
                className="form-control"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onMouseOut={(e) => setEmail(e.target.value)}
              />
            </div>

            { userMessage && <div style={{ color: 'red' }}>{userMessage}</div> }

            <div className="form-group py-2 fs-4">
              <button className="btn btn-success" 
                style={{ padding: '8px', fontSize: '17px', marginTop: '10px', marginBottom: '10px', color: '#ffffff', backgroundColor: '#198754', border: '1px solid #28a745' }} 
                onClick={subscribeHandler}>
                  Subscribe
              </button>
            </div>
            <hr/>

            <p>
              Note this is a private email distribution which requires that you
              (a) provide a valid email address and (b) be designated as a
              recipient by Department of Transportation. Moderators will discard
              subscription requests from non-approved users.
            </p>
          </div>
          
        </div>
      </div>
      )}
    </>
  )
}

export default Subscribe